import { Modal } from '@foxrenderfarm/widgets'
import { Breadcrumb, Catalogue, ChatSupport, Tab } from '../../../../components'
import { ArtTemplateContext } from '../../../../interface'
import {
  Container,
  ArtWrapper,
  Wrapper,
  Title,
  InnerHTML,
  QuickLinksTitle,
  QuickLink,
  QuickLinksWrapper,
} from './atoms'
import { useState } from 'react'
import { romanize } from '../../../../utils'
import { LinkArrow } from './svg/link-arrow'
import { removeHTMLTag } from '@foxrenderfarm/common'

interface Props {
  pageContext: ArtTemplateContext
}

interface QuickLinkProps {
  tag: string
  title: string
  tagIndex: number
  serialNumber: number
}

export const ArtContent = ({ pageContext }: Props) => {
  const { dirs, firstSubDirs, currentSlug, rootSlug, artContent, currentName, title } = pageContext
  const [imgModal, setImgModal] = useState(false)
  const [currentImgSrc, setCurrentImgSrc] = useState('')

  const handleClickArtImage = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const target = e.target as HTMLImageElement
    if (target.localName === 'img') {
      setCurrentImgSrc(target.currentSrc)
      setImgModal(true)
    }
  }

  function initialAnchorMap() {
    const anchorMap = new Map<string, QuickLinkProps>()
    const anchorItems = artContent.match(/<(h2|h3)[^>]*>(.*?)<\/(h2|h3)>/g)
    const reg = /<h(\d+)[^>]*>(.*)<\/(h2|h3)>/
    if (anchorItems) {
      let h2index = 0
      let h3index = 0
      let h3SerialNumber = 1
      anchorItems.forEach((anchor, index) => {
        const tag = anchor.match(reg)?.[1]
        const title = anchor.match(reg)?.[2]
        tag === '2' && (h3SerialNumber = 1)
        tag &&
          title &&
          anchorMap.set(String(index), {
            tag,
            title,
            tagIndex: tag === '2' ? h2index : h3index,
            serialNumber: tag === '2' ? h2index : h3SerialNumber,
          })
        if (tag === '2') {
          h2index++
        } else {
          h3SerialNumber++
          h3index++
        }
      })
    }
    return anchorMap
  }

  const handleClickQuickLink = (currentTarget: QuickLinkProps) => {
    const targetElement = document.getElementsByTagName(currentTarget.tag === '2' ? 'h2' : 'h3')[
      currentTarget.tagIndex
    ]
    window.scrollTo({ top: targetElement.offsetTop - 158, behavior: 'smooth' })
  }

  return (
    <Wrapper>
      <Tab dirs={dirs} firstSubDirs={firstSubDirs} currentSlug={currentSlug} rootSlug={rootSlug} />
      <Container>
        <Catalogue
          firstSubDirs={firstSubDirs}
          currentSlug={currentSlug}
          rootSlug={rootSlug}
          hiddenInMobile
        />
        <ArtWrapper>
          <Breadcrumb
            dirs={dirs}
            currentSlug={currentSlug}
            currentName={currentName}
            hideInMobile
          />
          <Title>{title}</Title>
          {initialAnchorMap().size > 0 && (
            <QuickLinksWrapper>
              <QuickLinksTitle>Quick Links</QuickLinksTitle>
              {[...initialAnchorMap().keys()].map((key) => {
                const currentTarget = initialAnchorMap().get(key)!
                return (
                  <QuickLink
                    key={key}
                    $tag={currentTarget.tag}
                    onClick={() => handleClickQuickLink(currentTarget)}
                  >
                    {currentTarget.tag === '2'
                      ? romanize(currentTarget.serialNumber + 1)
                      : currentTarget.serialNumber}
                    . {removeHTMLTag(initialAnchorMap().get(key)!.title).replace(/&nbsp;/g, ' ')}
                    <LinkArrow />
                  </QuickLink>
                )
              })}
            </QuickLinksWrapper>
          )}
          <InnerHTML
            dangerouslySetInnerHTML={{ __html: artContent }}
            onClick={(e) => handleClickArtImage(e)}
          />
        </ArtWrapper>
      </Container>
      <Modal visible={imgModal} onCancel={() => setImgModal(false)}>
        <img src={currentImgSrc} alt='' style={{ maxWidth: '90vw' }} />
      </Modal>
      <ChatSupport hiddenInPC />
    </Wrapper>
  )
}
